import './with-hover.module.scss';
import { useState } from 'react';


export interface withHoverProps {
  isHovering: boolean;
  onMouseEnter?: () => void;
  onMouseOut?: () => void;
}

/**
 * Component to be used for hover
 * @param WrapperComponent - React.ComponentType<T>
 * @example withHover()
 * @returns 
 */
export function withHover<T>(
  WrapperComponent: React.ComponentType<T>
): React.FC<T> {
  /**
   * 
   * @param props - React.FC<T>
   * @example TranslatedComponent()
   * @returns 
   */
  const TranslatedComponent: React.FC<T> = (props: T) => {
    const [hover, updateHover] = useState(false);
    return (
      <WrapperComponent
        {...(props as T)}
        onMouseEnter={() => updateHover(true)}
        onMouseOut={() => updateHover(false)}
        isHovering={hover}
      />
    );
  };
  return TranslatedComponent;
}

export default withHover;
